//@flow
import Constants   from   "../constants";
import Dispatcher  from '../dispatcher';

import type { Location } from 'react-router';

export default {
  changingRoute(location:Location) {
    Dispatcher.dispatchAction(Constants.CHANGING_ROUTE, { location });
  },

  addLoadingSpinner() {
    Dispatcher.dispatchAction(Constants.IS_LOADING);
  },

  removeLoadingSpinner() {
    Dispatcher.dispatchAction(Constants.LOAD_COMPLETED);
  },
};
